module.exports = __webpack_public_path__ + "img/btn-lesson-flow.7a55a958.jpg";